module.exports = __webpack_public_path__ + "60f877e7e7b92360ce248c3d13e2f71b.woff2";